import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const http = axios.create({ baseURL: API, withCredentials: true });

// Silent session refresh: when the short-lived access-token cookie has expired a
// request returns 401; call /auth/refresh once (using the 7-day refresh cookie),
// then retry the original request. Concurrent 401s share one refresh call.
const REFRESH_SKIP = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout"];
let refreshPromise = null;

function refreshSession() {
  if (!refreshPromise) {
    refreshPromise = http.post("/auth/refresh").finally(() => {
      refreshPromise = null;
    });
  }
  return refreshPromise;
}

http.interceptors.response.use(
  (res) => res,
  async (error) => {
    const { response, config } = error;
    const url = config?.url || "";
    if (
      !response ||
      response.status !== 401 ||
      !config ||
      config._retry ||
      REFRESH_SKIP.some((p) => url.includes(p))
    ) {
      return Promise.reject(error);
    }
    config._retry = true;
    try {
      await refreshSession();
      return http(config);
    } catch (e) {
      return Promise.reject(error);
    }
  }
);

export const money = (v) =>
  "$" +
  Number(v || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
